import { BaseCrudService } from '../../shared/_utils/services/base-crud-service';
import { Injector, Injectable } from '@angular/core';
import { LazyLoadEvent } from 'primeng/api';
import { HttpParams } from '@angular/common/http';
import { QueryOperator } from '../../shared/_utils/services/query-operator.enum';
import { AauditProcessBody } from '../entities/aaudit-process-body';

@Injectable()
export class AauditProcessBodyService extends BaseCrudService<AauditProcessBody> {

    public uri = '/api/aauditProcessBody/';

    constructor(injector: Injector) {
        super(injector);
    //    console.log('Instance AauditProcessService');
    }

    buildSentence(entity?: AauditProcessBody, event?: LazyLoadEvent): HttpParams {
    if (entity) {
        let query = '';
        if (entity.aauditProcessHead && entity.aauditProcessHead.id) {
            query = query.concat(
                `aauditProcessHead.id${QueryOperator.Equal}${entity.aauditProcessHead.id}${QueryOperator.Split}`
            );
        }

        this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
    }

    if (event) {
        const page = ((event.first + event.rows) / event.rows - 1).toString();
        const size = event.rows.toString();
        this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
        this.httpParams = this.httpParams.set(QueryOperator.SizeParam, size);
        
        this.httpParams = this.httpParams.set(QueryOperator.SizeParam, size);

    }
    let sortOrder = 'desc';
    this.httpParams =  this.httpParams.set(QueryOperator.SortParam, `id,${sortOrder}`);


    return this.httpParams;
    }
   
}




// WEBPACK FOOTER //
// ./src/app/core/services/aaudit-process-body.service.ts